
import React, { useEffect, useState } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { useAuth, AuthProvider } from './contexts/AuthContext';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import Dashboard from './components/Dashboard/Dashboard';
import DomainRegistration from './components/Dashboard/DomainRegistration';
import Profile from './components/Profile/Profile';
import PrivateRoute from './components/PrivateRoute';
import { ConfigProvider } from 'antd';
import AppRoutes from './AppRoutes';
import { supabase } from './services/supabase';

function App() {
  return (    
    <ConfigProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default React.memo(App);
